<template>
  <b-card no-body>
    <b-card-body>
      <b-card bg-variant="light" data-manual-filter :body-class="filtersOpen ? '' : 'lg-filter-collapsed'">
        <button
          type="button"
          class="btn btn-outline-primary lg-filter-toggle w-100 d-flex justify-content-between align-items-center mb-2"
          @click="toggleFilters"
        >
          <span class="d-flex align-items-center">
            <b-icon icon="funnel" font-scale="1.1" class="mr-2"></b-icon>
            <span>Filtros</span>
          </span>
          <b-icon :icon="filtersOpen ? 'chevron-up' : 'chevron-down'" font-scale="1.1"></b-icon>
        </button>

        <div class="lg-filter-container" v-show="filtersOpen">
        <b-form-row @keyup.enter="load">
          <b-col lg="2" sm="12" class="text-left">
            <lg-form-input invalidFeedback="A sigla deve ser informada!" description="" v-model="filterSigla"
              label="Sigla" />
          </b-col>

          <b-col lg="3" sm="12" class="text-left">
            <lg-form-input invalidFeedback="A descrição deve ser informada!" description="" v-model="filterDescricao"
              label="Descrição:" />
          </b-col>

          <b-col lg="2" sm="12" class="text-left">
            <lg-form-const-select @change="load()" label="Situação:" v-model="situacao"
              :options="optionsFilterSituacao" />
          </b-col>
          <b-col class="ml-4 d-flex align-items-center">
            <b-button id="lupa" class="ml-3 mr-2 my-2" size="sm" style="height: 20px" pill variant="primary"
              @click="load">
              <div class="btn-size-alinhamento">
                <b-icon icon="search" />
              </div>
              <b-tooltip target="lupa" title="Localizar" triggers="hover focus"></b-tooltip>
            </b-button>
          </b-col>
          <b-col class="text-right d-flex justify-content-end align-items-center">
            <b-button id="novoUnidade" class="ml-3 mr-2 my-2" style="height: 20px" size="sm" pill variant="secondary"
              @click="showModalAdicionar = true">
              <div class="btn-size-alinhamento">
                <b-icon scale="1" icon="plus" />
              </div>
              <b-tooltip target="novoUnidade" title="Adicionar novo..."></b-tooltip>
            </b-button>
          </b-col>
        </b-form-row>
        </div>
      </b-card>

      <b-card bg-variant="light">
        <b-table responsive small :busy="this.busy" :items="this.records" :fields="this.tableFields" :hover="true"
          @row-dblclicked="unidadeFederativaSelect" show-empty>
          <template #empty>
            <p>Nenhum registro encontrado</p>
          </template>

          <template #table-busy>
            <div class="text-center text-primary my-2">
              <b-spinner class="align-middle"></b-spinner>
            </div>
          </template>
          <template #cell(acoes)="{ item }">
            <div class="d-flex align-items-center justify-content-end">
              <b-button :id="'editar' + item.id" class="mx-3" size="sm" pill variant="primary"
                @click="ModalEditar(item)">
                <b-icon icon="pencil-square" />
                <b-tooltip :target="'editar' + item.id" title="Editar..." triggers="hover"></b-tooltip>
              </b-button>
              <b-form-checkbox v-model="item.situacao" @change="alteraSituacao(item)" name="check-button" switch
                size="lg" :value="1" :unchecked-value="0" class="text-right pb-2" :id="'situacao-uf' + item.id" />
              <b-tooltip :target="'situacao-uf' + item.id" title="Alterar situação" triggers="hover"
                class="text-right"></b-tooltip>
            </div>
          </template>
        </b-table>

        <b-row style="margin-top: 12px" v-if="records && records.length > 0">
          <b-col cols="6" style="display: flex; align-items: center; font-size: 12px">
            <b-col cols="6" style="display: flex; align-items: center; font-size: 12px">Página {{ page }} de {{
              totalPage }} -
              {{ total }} registros</b-col>
            <b-col cols="6" style="display: flex; align-items: center; font-size: 12px">Mostrando:&nbsp;
              <b-form-select size="sm" v-model="perPage" @change="() => this.load()" :options="perPageOptions">
              </b-form-select>
            </b-col>
          </b-col>
          <b-col cols="6">
            <div class="d-flex justify-content-end align-items-end">
              <b-pagination style="margin-bottom: 10px; margin-top: 10px" v-model="page" :per-page="perPage"
                :total-rows="total"></b-pagination>
            </div>
          </b-col>
        </b-row>
        <UnidadeFederativaAdicionar v-if="showModalAdicionar" :prefix="updatedPrefix" @fechar="fechar" :id="idEdit">
        </UnidadeFederativaAdicionar>
      </b-card>
    </b-card-body>
  </b-card>
</template>
<script>
import LgFormConstSelect from "@/core/components/Form/LgFormConstSelect.vue";
import LgFormInput from "@/core/components/Form/LgFormInput.vue";
import { ListResourceMixin } from "@/core/mixins/resource";
import ResourceService from "@/core/api/ResourceService";
import UnidadeFederativaAdicionar from "@/modules/cadastros/unidadefederativa/UnidadeFederativaAdicionar.vue";
import ConfirmMixin from "@/core/mixins/confirm";

export default {
  components: {
    LgFormInput,
    LgFormConstSelect,
    UnidadeFederativaAdicionar,
  },

  props: {
    onDblClickUnidadeFederativa: Function,
    codEmpresa: Number,
    prefix: {
      Array,
      default: ()=>[]
    },
  },

  data() {
    return {
      filtersOpen: true,
      filterSigla: "",
      filterDescricao: "",
      perPage: 10,
      perPageOptions: [10, 25, 50, 100],
      situacao: 1,
      idEdit: null,
      showModalAdicionar: false,
      optionsFilterSituacao: [
        { key: "filterSituacao", text: "Todos", value: undefined },
        { key: "filterSituacao", text: "Ativo", value: 1 },
        { key: "filterSituacao", text: "Inativo", value: 0 },
      ],
    };
  },

  mixins: [ListResourceMixin, ConfirmMixin],

  beforeMount() {
    this.$service = new ResourceService(`/api/unidade-federativa`);
  },

  mounted() {
    this.load();
  },

  computed: {
    updatedPrefix() {
      return [...this.prefix, "Unidade Federativa"];
    },
    title() {
      return this.updatedPrefix.join(" > ");
    },
    tableFields() {
      return [
        { key: "uf", label: "Sigla", tdClass: "px-3" },
        { key: "descricao", label: "Descrição", tdClass: "px-2" },
        { key: "acoes", label: "" },
      ];
    },
  },
  watch: {
    page() {
      this.load()
    },
  },

  methods: {
    toggleFilters() {
      this.filtersOpen = !this.filtersOpen
    },
    ModalEditar(item) {
      this.idEdit = item.id;
      this.showModalAdicionar = true;
    },
    fechar() {
      this.showModalAdicionar = false;
      this.idEdit = null;
      this.load();
    },
    async load() {
      let filtro = {};

      if (this.filterSigla) {
        filtro.filterSigla = this.filterSigla;
      }

      if (this.filterDescricao) {
        filtro.filterDescricao = this.filterDescricao;
      }

      if (this.situacao != undefined) {
        filtro.situacao = this.situacao;
      }
      this.busy = true;
      await this.$loadResource({
        size: this.perPage,
        page: this.page,
        params: filtro,
      });
    },

    clearForm() {
      this.filterSigla = "";
      this.filterDescricao = "";
      this.situacao = 1;

      this.load();
    },

    async unidadeFederativaSelect(item) {
      this.$emit("onDblClickUnidadeFederativa", item);
    },

    async alteraSituacao(item) {
      let response = await this.$confirm(
        "Deseja " + (item.situacao === 1 ? "ativar" : "desativar") + " a Unidade Federativa?",
        item.descricao
      )
      if (response) {
        this.confirmarAlteracaoSituacao(item)
      } else {
        item.situacao = item.situacao === 1 ? 0 : 1
      }
    },


    async confirmarAlteracaoSituacao(item) {
 
      const { status } = await this.$service.alteraSituacao(item);
      if (status == 200) {
        this.$notify({
          type: "success",
          message: `Registro ${item.situacao ? "Ativado" : "Desativado"
            } com sucesso!`,
        });
      } else {
        this.$notify({
          type: "danger",
          message: `Erro ao ${item.situacao ? "Ativar" : "Desativar"
            } o registro!`,
        })
      }
    },

  },
};
</script>
